import { AxiosResponse } from "axios";
import { all, call, put, takeEvery } from "redux-saga/effects";
import api from "../../api";
import Endpoint from "../../shared/endpoints";
import paymentConstants from "../constants/paymentConstants";

const getPayments = (payload: any) =>
  api.get(Endpoint.retrievePayments, {
    params: {
      ...(payload.clientId && { client: payload.clientId }),
      page: payload.page,
      ...(payload.searchText && { search: payload.searchText }),
      ...(payload.currency && { currency_name: payload.currency }),
      ...(payload.status && { status: payload.status }),
      ...(payload.dateRange &&
        payload.dateRange.from && {
          created_at_after: payload.dateRange.from,
          created_at_before: payload.dateRange.to,
        }),
    },
  });

const getPaymentDetails = (payload: any) =>
  api.get(`${Endpoint.retrievePaymentDetails}/${payload.id}/`);

const createPayment = (payload: any) =>
  api.post(Endpoint.createPayment, payload);

const updatePayment = (payload: any) =>
  api.patch(`${Endpoint.updatePayment}/${payload.id}/`, {
    ...(payload.status && { status: payload.status }),
  });

function* getPaymentsAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(getPayments, action.payload);

    yield put({
      type: paymentConstants.GET_PAYMENTS_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: paymentConstants.GET_PAYMENTS_FAILURE, err: e });
  }
}

function* getPaymentDetailsAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(
      getPaymentDetails,
      action.payload,
    );

    yield put({
      type: paymentConstants.GET_PAYMENT_DETAILS_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: paymentConstants.GET_PAYMENT_DETAILS_FAILURE, err: e });
  }
}

function* createPaymentAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(createPayment, action.payload);

    yield put({
      type: paymentConstants.CREATE_PAYMENT_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: paymentConstants.CREATE_PAYMENT_FAILURE, err: e });
  }
}

function* updatePaymentAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(updatePayment, action.payload);

    yield put({
      type: paymentConstants.UPDATE_PAYMENT_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: paymentConstants.UPDATE_PAYMENT_FAILURE, err: e });
  }
}

function* paymentSaga() {
  yield all([
    takeEvery(paymentConstants.GET_PAYMENTS_REQUEST, getPaymentsAsync),
  ]);
  yield all([
    takeEvery(
      paymentConstants.GET_PAYMENT_DETAILS_REQUEST,
      getPaymentDetailsAsync,
    ),
  ]);
  yield all([
    takeEvery(paymentConstants.CREATE_PAYMENT_REQUEST, createPaymentAsync),
  ]);
  yield all([
    takeEvery(paymentConstants.UPDATE_PAYMENT_REQUEST, updatePaymentAsync),
  ]);
}

export default paymentSaga;
